export enum PageType {
    MarkdownOnly = 'markdown_only',
    MarkdownOnlyNoCard = 'markdown_only_no_card',
    QuestionHorizontal = 'question_horizontal',
    QuestionVertical = 'question_vertical',
    QuestionInput = 'question_input',
    AudioContent = 'audio_content',
    QuestionMultiselect = 'question_multiselect',
    VideoContent = 'video_content',
}

export enum NewPageTypes {
    Content = 'content',
    SingleSelectQuestion = 'single_select',
    MultiSelectQuestion = 'multi_select',
    TextInputQuestion = 'text_input',
    Audio = 'audio',
    Video = 'video',
}

export const PageConversion = {
    [PageType.MarkdownOnly]: NewPageTypes.Content,
    [PageType.MarkdownOnlyNoCard]: NewPageTypes.Content,
    [PageType.QuestionHorizontal]: NewPageTypes.SingleSelectQuestion,
    [PageType.QuestionVertical]: NewPageTypes.SingleSelectQuestion,
    [PageType.QuestionMultiselect]: NewPageTypes.MultiSelectQuestion,
    [PageType.QuestionInput]: NewPageTypes.TextInputQuestion,
    [PageType.AudioContent]: NewPageTypes.Audio,
    [PageType.VideoContent]: NewPageTypes.Video,
};
